// @flow
import styled from "styled-components";
import * as React from "react";
import { TextContainer, Text } from "./styles";
import { getTimes } from "../../Timer";

const TextWrapper = styled(TextContainer)`
  flex-grow: 0;
  flex-basis: auto;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 0 15px;
`;

const Container = styled(TextContainer)`
  width: 100%;
  margin-bottom: 24px;

  @media (max-width: 959px) {
    padding-top: 20px;
    padding-bottom: 0;
  }

  @media (min-width: 480px) and (max-width: 959px) {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
`;

const TimeWrapper = styled(Text)`
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
`;

type Props = {
  Cup: React.Node,
  className?: string,
  children: React.Node
};

function Header({ Cup, children, className, ...props }: Props) {
  const { startTime, endTime } = getTimes(props);
  const start = startTime.format("LLL");
  const finish = endTime.format("LLL");

  return (
    <Container className={className}>
      <Cup />
      <TextWrapper>
        {children}
        <TimeWrapper>
          {start} / {finish}
        </TimeWrapper>
      </TextWrapper>
    </Container>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/Header.js